export default ({ $aditude, store }) => {
	window.dataLayer = window.dataLayer || [];

	// Prevent double-wrapping if plugin is ever re-evaluated
	if (window.dataLayer.__dataLayerPushWrapped) {
		return;
	}

	const oldPushFunction = window.dataLayer.push;

	const hasConsentLoadedAdsInDataLayer = () => {
		// dataLayer is an Array; entries are commonly objects, but can be other types
		return window.dataLayer.some(
			(item) =>
				item &&
				typeof item === "object" &&
				item.event === "consent-loaded" &&
				item.eventPayload === "load-ads"
		);
	};

	const loadAditude = () => {
		if (
			!store?.getters["features/isFeatureEnabled"]?.("DisableThirdParty")
		) {
			// Double guard just to prevent reloading aditude cuz I was getting an error
			if (window.dataLayer.__aditudeLoaded) {
				return;
			}

			$aditude.loadAditude();
			window.dataLayer.__aditudeLoaded = true;
			console.log("+++ Aditude loaded");
		}
	};

	const loadExco = () => {
		if (
			!store?.getters["features/isFeatureEnabled"]?.("DisableThirdParty")
		) {
			if (window.dataLayer.__excoLoaded) {
				return;
			}

			// Add the script tag for the EXCO ads.
			const fjs = document.getElementsByTagName("script")[0];
			const js = document.createElement("script");
			js.className = "exco-player";
			js.setAttribute("programmatic", "true"); // If programmatic control is enabled player won't start loading until api.init() is called
			const playerId =
				process.env.NUXT_ENV_STAGE === "prod"
					? "722bf882-df54-4b64-a54f-b86c95d9e200"
					: "e5d6defa-1679-4434-9a2c-e467f66697f3";
			js.onload = function () {
				store.commit("ads/SET_IS_EXCO_LOADED", true);
			};
			js.src = `//player.ex.co/player/${playerId}`;
			fjs.parentNode.insertBefore(js, fjs);

			window.dataLayer.__excoLoaded = true;
			console.log("+++ EXCO loaded");
		}
	};

	// 1) Historical guard: if GTM somehow already pushed the consent event before we wrapped the push function
	if (hasConsentLoadedAdsInDataLayer()) {
		loadAditude();
		loadExco();
	}

	// 2) Future guard: load ads when consent is given/reloaded/updated
	window.dataLayer.push = function (...args) {
		if (
			args[0]?.event === "consent-loaded" &&
			args[0]?.eventPayload === "load-ads"
		) {
			loadAditude();
			loadExco();
		}

		window.dataLayer.__dataLayerPushWrapped = true;

		// Proceed calling the previous window.dataLayer.push reference as if nothing happened
		const prevArguments = [].slice.call(args, 0);
		return oldPushFunction.apply(window.dataLayer, prevArguments);
	};

	// 3) Explicit load flag
	if (store?.getters["features/isFeatureEnabled"]?.("ImmediateAdLoad")) {
		loadAditude();
		loadExco();
	}
};
